/*
 * Navigasi dashboard baru — 8 grup, 33 tujuan.
 *
 * MURNI DATA, disalin dari `prototype/js/data.js` paket client. Kalau client
 * mengirim versi baru, salin ulang berkas ini saja.
 *
 * `legacy` adalah kuncinya. Selama layar barunya belum dibangun, item menunjuk
 * ke URL lama di /siteadmin — jadi navigasi baru sudah utuh 33 item sejak hari
 * pertama, dan layar ditukar satu per satu di bawahnya tanpa client perlu tahu
 * mana yang mana.
 *
 * `next` berisi URL layar BARU dan menang atas `legacy`. Setiap kali sebuah
 * layar dibangun, `next`-nya harus ditambahkan di sini — dan yang paling mudah
 * terlewat justru layar yang sudah ada lebih dulu: waktu mekanisme ini dipakai
 * untuk Live jobs, item Dispatch tetap tanpa `next`, jadi item PERTAMA di
 * sidebar melempar orang keluar dari dashboard barunya sendiri.
 *
 * `badge` menyebut KUNCI angka, bukan angkanya. Angkanya datang dari
 * getDispatchOverview dan harus sama dengan yang dilihat layar tujuannya —
 * badge yang tidak cocok dengan isinya melatih orang mengabaikan badge.
 *
 * Dua item ber-`legacy: null` belum punya padanan sama sekali di dashboard
 * lama: persetujuan provider (butuh kolom UserDocument.status dan
 * documentsReviewedAt yang belum ada) dan audit log (tabelnya belum dibuat).
 * Keduanya dinonaktifkan di sidebar sampai backend-nya ada — tautan yang
 * membuang orang ke halaman kosong lebih buruk daripada item yang jelas mati.
 */

const NAV = [
  {
    group: 'Overview',
    items: [
      { id: 'dispatch', label: 'Dispatch', icon: 'gauge', next: '/admin', legacy: '/siteadmin' }
    ]
  },
  {
    group: 'Operations',
    items: [
      // Layar barunya sudah ada — `next` menang atas `legacy`.
      { id: 'live', label: 'Live jobs', icon: 'truck', next: '/admin/live-jobs', legacy: '/siteadmin/jobs', badge: 'activeJobs' },
      { id: 'direct', label: 'Direct bookings', icon: 'inbox', next: '/admin/direct-bookings', legacy: '/siteadmin/direct-bookings', badge: 'unassignedDirect' },
      { id: 'scheduled', label: 'Scheduled', icon: 'calendar', next: '/admin/scheduled', legacy: '/siteadmin/schedule-jobs' },
      { id: 'completed', label: 'Completed', icon: 'check', next: '/admin/completed', legacy: '/siteadmin/completed-jobs' },
      { id: 'cancelled', label: 'Cancelled', icon: 'x', next: '/admin/cancelled', legacy: '/siteadmin/cancelled-jobs' },
      { id: 'tracking', label: 'Live tracking', icon: 'route', next: '/admin/tracking', legacy: '/siteadmin/tracking' }
    ]
  },
  {
    group: 'People',
    items: [
      { id: 'customers', label: 'Customers', icon: 'users', next: '/admin/customers', legacy: '/siteadmin/users' },
      { id: 'providers', label: 'Providers', icon: 'wrench', next: '/admin/providers', legacy: '/siteadmin/partners' },
      { id: 'approvals', label: 'Provider approvals', icon: 'shield', next: '/admin/provider-approvals', legacy: null },
      { id: 'ratings', label: 'Ratings & reviews', icon: 'star', next: '/admin/ratings', legacy: '/siteadmin/ratings' }
    ]
  },
  {
    group: 'Money',
    items: [
      { id: 'payouts', label: 'Payouts', icon: 'wallet', next: '/admin/payouts', legacy: '/siteadmin/payout' },
      { id: 'failed', label: 'Failed payouts', icon: 'x', next: '/admin/failed-payouts', legacy: '/siteadmin/failed-payout', badge: 'failedPayouts' },
      { id: 'currency', label: 'Currencies', icon: 'coins', next: '/admin/currencies', legacy: '/siteadmin/currency' },
      { id: 'gateways', label: 'Payment gateways', icon: 'card', next: '/admin/payment-gateways', legacy: '/siteadmin/payment-gateway' }
    ]
  },
  {
    group: 'Catalogue',
    items: [
      { id: 'services', label: 'Services', icon: 'grid', next: '/admin/services', legacy: '/siteadmin/category' },
      { id: 'subservices', label: 'Sub-services', icon: 'layers', next: '/admin/sub-services', legacy: '/siteadmin/sub-category' },
      { id: 'pricing', label: 'Pricing', icon: 'coins', next: '/admin/pricing', legacy: '/siteadmin/pricing/list' },
      { id: 'areas', label: 'Service areas', icon: 'pin', next: '/admin/service-areas', legacy: '/siteadmin/location' },
      { id: 'promos', label: 'Promo codes', icon: 'tag', next: '/admin/promo-codes', legacy: '/siteadmin/promo-code/list' },
      { id: 'reasons', label: 'Cancel reasons', icon: 'x', next: '/admin/cancel-reasons', legacy: '/siteadmin/cancel-reasons' }
    ]
  },
  {
    group: 'Content',
    items: [
      // Enam layar Homepage Settings lama sudah diganti satu halaman Website
      // Content, jadi ini menunjuk ke situ, bukan ke /siteadmin/homepage/*.
      { id: 'website', label: 'Website content', icon: 'image', next: '/admin/website-content', legacy: '/siteadmin/website-content' },
      { id: 'static', label: 'Static pages', icon: 'doc', next: '/admin/static-pages', legacy: '/siteadmin/staticpage/manage' },
      { id: 'content', label: 'Content pages', icon: 'doc', next: '/admin/content-pages', legacy: '/siteadmin/contentpage/manage' }
    ]
  },
  {
    group: 'Communications',
    items: [
      { id: 'push', label: 'Push notifications', icon: 'bell', next: '/admin/push-notifications', legacy: '/siteadmin/notifications' },
      { id: 'precaution', label: 'Precaution notices', icon: 'chat', next: '/admin/precaution-notice', legacy: '/siteadmin/precaution-notification' },
      { id: 'sms', label: 'SMS providers', icon: 'sms', next: '/admin/sms-providers', legacy: '/siteadmin/sms-methods' }
    ]
  },
  {
    group: 'System',
    items: [
      { id: 'site', label: 'Site settings', icon: 'cog', next: '/admin/site-settings', legacy: '/siteadmin/settings/site' },
      { id: 'mobile', label: 'Mobile apps', icon: 'phone', next: '/admin/mobile-apps', legacy: '/siteadmin/settings/mobile-app' },
      { id: 'config', label: 'Configuration', icon: 'cog', next: '/admin/config', legacy: '/siteadmin/settings/config' },
      { id: 'admins', label: 'Admin users', icon: 'users', next: '/admin/admin-users', legacy: '/siteadmin/admin-users' },
      { id: 'roles', label: 'Roles & permissions', icon: 'key', next: '/admin/roles', legacy: '/siteadmin/admin-roles' },
      { id: 'audit', label: 'Audit log', icon: 'shield', next: '/admin/audit-log', legacy: null }
    ]
  }
];

export default NAV;
